import { Component, OnInit } from '@angular/core';
import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'app-custom-header',
  templateUrl: './custom-header.component.html',
  styleUrls: ['./custom-header.component.scss', '../header/header.component.scss']
})
export class CustomHeaderComponent extends HeaderComponent implements OnInit {

  constructor() { 
    super();
  }

  ngOnInit() {
  }

}
